import React from "react";
import { connect } from "react-redux";
class UserImage extends React.Component {
  render() {
    return (
      <>
        <img
          src={
            this.props.loginUser.image ||
            require("../../assets/images/no_image.jpg")
            // src={
            //   require("../../assets/images/event.jpg")
          }
          className="profile-images img-fluid"
          alt="jpg"
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  const { loginUser } = state.login;
  return { loginUser };
};

export default connect(mapStateToProps, {})(UserImage);
